/*eslint-disable*/
import { getSchedulesPage } from "../api/AuthenticationServices";
import "../assets/styles/Achievements.css";
import "../assets/styles/Schedules.css";

import { useState } from "react";
import { useEffect } from "react";
const ScheduleCard = ({ title, description, time, place, date, opponent }) => {
  return (
    <div className="body">
      <div className="card-container">
        <div className="card-content">
          <h2>{title}</h2>
          <h4>Place : {place}</h4>
          <h4>Date : {date}</h4>
          <h4>Time : {time}</h4>
          <h4>Opponent : {opponent}</h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};
function Schedules() {
  const [records, setRecords] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    try {
      const res = await getSchedulesPage();
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", records);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }

  return (
    <div className="card-wrapper">
      <h2
        style={{
          textAlign: "center",
          color: "white",
          fontFamily: "'Delicious Handrawn', cursive",
          fontSize: "40px",
        }}
      >
        SCHEDULES
      </h2>
      {records.length > 0 ? (
        records.map((item) => {
          return (
            <div className="card-space">
              <ScheduleCard
                title={item.title}
                place={item.place}
                date={item.dateOfSch}
                opponent={item.opponent}
                description={item.description}
                time={item.time}
              />
            </div>
          );
        })
      ) : (
        <h3>No Schedules Found </h3>
      )}
    </div>
  );
}

export default Schedules;
